import React, { useState, useEffect } from 'react';
import { Modal, Button, Select, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { fetchTeachers } from '../../ApiServices/teacherService';

const { Option } = Select;

const CreateClassModal = () => {
  const [visible, setVisible] = useState(false);
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const navigate = useNavigate();

  const loadTeachers = async () => {
    try {
      setLoading(true);
      const teachersData = await fetchTeachers();
      setTeachers(teachersData);
    } catch (error) {
      console.error("Error fetching teachers:", error);
      message.error("Failed to fetch teachers");
    } finally {
      setLoading(false);
    }
  };

  const showModal = () => {
    setVisible(true);
    loadTeachers();
  };

  const handleCancel = () => {
    setVisible(false);
    setSelectedTeacher(null);
  };

  const handleSubmit = () => {
    if (!selectedTeacher) {
      message.error("Please select a teacher");
      return;
    }
    
    const teacher = teachers.find(t => t.id === selectedTeacher);
    
    navigate('/teacher-home', {
      state: {
        userId: selectedTeacher,
        name: teacher.name
      }
    });
    
    setVisible(false);
  };

  return (
    <>
      <Button 
        type="primary" 
        onClick={showModal}
        style={{ marginRight: 8 }}
      >
        Create Class
      </Button>
      
      <Modal
        title="Create New Class"
        visible={visible}
        onOk={handleSubmit}
        onCancel={handleCancel}
        confirmLoading={loading}
      >
        <Select
          style={{ width: '100%' }}
          placeholder="Select a teacher"
          loading={loading}
          onChange={(value) => setSelectedTeacher(value)}
        >
          {teachers.map(teacher => (
            <Option key={teacher.id} value={teacher.id}>
              {teacher.name || `${teacher.firstName} ${teacher.lastName}`}
            </Option>
          ))}
        </Select>
      </Modal>
    </>
  );
};

export default CreateClassModal;